<template>
  <v-container
      id="user-profile"
      fluid
      tag="section"
  >
<!--    <base-material-card outlined icon="mdi-cash-multiple" class="overflow-visible order-list__wrapper">-->

      <v-row style="background-color: white; margin: 5px; padding: 70px 25px">
        <v-col cols="7">
          <div class="font-weight-bold mt-2 text-uppercase">Hướng dẫn báo lỗi sản phầm</div>
          <div class="wrapper-left-content">
            <v-row class="font-weight-bold">Bấm nút [ Báo lỗi ] và điền các thông tin theo hướng dẫn sau:</v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0">
                Người báo lỗi:
              </v-col>
              <v-col cols="9">
                Tên telegram hoặc tên đăng nhập CRM
              </v-col>
            </v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0 pt-0">
                Contact user:
              </v-col>
              <v-col cols="9" class="pt-0">
                Số điện thoại mà phụ huynh dùng để đăng ký tài khoản
            </v-col>
            </v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0 pt-0">
                Thông tin thiết bị:
              </v-col>
              <v-col cols="9" class="pt-0">
                Máy gì? Hệ điều hành bao nhiêu?
              </v-col>
            </v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0 pt-0">
                Mô tả chi tiết lỗi:
              </v-col>
              <v-col cols="9" class="pt-0">
                <span class="text-uppercase font-italic font-weight-bold mr-1" style="color: #c63131">Ghi rõ</span>
                lỗi ở khóa học + bài học + câu nào và Thao tác như thế nào thì bị lỗi
              </v-col>
           </v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0 pt-0">
                Bộ phận báo lỗi:
              </v-col>
              <v-col cols="9" class="pt-0">
                Sale
              </v-col>
            </v-row>
            <v-row class="ml-1">
              <v-col cols="3" class="font-weight-bold font-italic pr-0 pt-0">
                Hình ảnh/Video:
              </v-col>
              <v-col cols="9" class="pt-0">
                Bấm tải lên ở form
              </v-col>
            </v-row>
            <v-row class="font-weight-bold font-italic">
              Lưu ý: Nhập tiếng việt có dấu
            </v-row>
          </div>
        </v-col>

        <v-col cols="1"></v-col>

        <v-col cols="4" style="padding-right: 50px">
          <div class="font-weight-bold mt-2 color-pink">Mẫu ví dụ:</div>
          <div class="wrapper-right-content">
            <v-row>
              <div class="mb-2">
                <span class="font-weight-bold font-italic">Người báo lỗi:</span>
                Nguyễn Văn Hưng
              </div>
            </v-row>
            <v-row>
              <div class="mb-2">
                <span class="font-weight-bold font-italic">Contact user:</span>
                0343 112 997
              </div>
            </v-row>
            <v-row>
              <div class="mb-2">
                <span class="font-weight-bold font-italic">Thông tin thiết bị:</span>
                samsung A7, android 8.0/máy dell, win 10, trình duyệt cốccốc.
              </div>
            </v-row>
            <v-row>
              <div class="mb-2">
                <span class="font-weight-bold font-italic">Mô tả chi tiết lỗi:</span>
                User bấm vào khóa học tiếng việt chân trời sáng tạo lớp 1, bài học đánh dấu vần ao, au -> không hiển thị đáp án câu 3.
              </div>
            </v-row>
            <v-row>
              <div class="mb-2">
                <span class="font-weight-bold font-italic">Bộ phận báo lỗi:</span> Sale
              </div>
            </v-row>
            <v-row>
              <div>
                <span class="font-weight-bold font-italic">Hình ảnh:</span> link ảnh/video
              </div>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-center mt-5">
            <a  class="btn-report-link-gg"
                target="_blank"
                href="https://docs.google.com/forms/d/e/1FAIpQLSdTP7b3It-gmSeSLXKWNoTUh866cKLJK5I1owbm5z5RKQCmhA/viewform">Báo lỗi</a>
          </div>
        </v-col>
      </v-row>
<!--    </base-material-card>-->
  </v-container>
</template>

<script>
export default {
  name: "errorProduct",
  methods: {
    linkToForm() {

    }
  }
}

</script>

<style scoped>
.wrapper-left-content {
  margin-top: 12px;
  padding: 20px;
  border: 1px solid #bbb9b9;
  border-radius: 5px;
}
.wrapper-right-content {
  border-left: 3px solid #eee;
  padding-left: 35px;
  margin-top: 25px;
}
.btn-report-link-gg {
  padding: 12px 35px;
  font-size: 18px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  background: #e91e63;
  border-radius: 10px;
}
.color-pink {
  color: #e91e63;
}
</style>